import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { AccumulationChartAllModule, ChartAllModule, RangeNavigatorAllModule } from '@syncfusion/ej2-angular-charts';
import { CategoriesModule } from 'apps/wsg/src/app/shared/categories/categories.module';
import { LocationsModule } from 'apps/wsg/src/app/shared/locations/locations.module';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { BilledRevenueDonutComponent } from './billed-revenue-donut/billed-revenue-donut.component';
import { EarnedRevenueDonutComponent } from './earned-revenue-donut/earned-revenue-donut.component';
import { RevenueByCategoryService } from './revenue-by-category.service';
import { TwoMonthCompareComponent } from './two-month-compare/two-month-compare.component';
import { PeriodsModule } from '../../shared/periods/periods.module';



@NgModule({
  declarations: [
    EarnedRevenueDonutComponent,
    BilledRevenueDonutComponent,
    TwoMonthCompareComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    CategoriesModule,
    PeriodsModule,
    ChartAllModule, 
    RangeNavigatorAllModule, 
    ButtonModule, 
    AccumulationChartAllModule,
  ],
  exports: [
    EarnedRevenueDonutComponent,
    BilledRevenueDonutComponent
  ],
  providers: [
    RevenueByCategoryService
  ]
})
export class RevenueByCategoryModule { }
